import { API } from '../config/config';

const SubscriptionService = {
  getAllSubscriptions: (start = 0, limit = 10, filters = {}, orderPayment = 'ASC') => {
    // Hardcodeamos la URL completa del dashboard
    const url = 'https://suscripciones-api.deh.host/api/dashboard';
    
    const params = {
      ...filters,
      start,
      limit,
      order_payment: orderPayment,
    };
    
    const token = localStorage.getItem('authToken');
    
    // Usamos fetch directamente para tener control total de la URL
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = `${url}?${queryString}`;
    
    return fetch(fullUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log('Dashboard data fetched successfully:', data);
        return data;
      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error);
        throw error;
      });
  },
};

export default SubscriptionService;